import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common');
  return (
    <select
      aria-label={t('language.label')}
      value={i18n.resolvedLanguage ?? 'en'}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      className="rounded-lg border border-border-subtle bg-white px-2 py-1 text-xs font-bold text-text-faint hover:text-text-main focus:border-primary focus:outline-none"
    >
      {SUPPORTED_LANGUAGES.map((lng) => (
        <option key={lng} value={lng}>
          {t(`language.${lng}`, { defaultValue: lng.toUpperCase() })}
        </option>
      ))}
    </select>
  );
}
